<template>
  <LoaderFullPage v-if="(!user || !isTopbarReady) && isTokenValid" />
  <template v-else>
    <RouterView />
    <AppProductTour
      v-if="!productTourCompleted && onboardingCompleted && isTokenValid"
      @product-tour-complete="productTourCompleted = true"
    />
  </template>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useAuthStore } from "@follaw-fr/stores/auth";
import { useUserStore } from "@follaw-fr/stores/user";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import AppProductTour from "@follaw-fr/components/general/templates/AppProductTour.vue";

const { isTokenValid } = storeToRefs(useAuthStore());
const { isTopbarReady } = storeToRefs(useUserStore());
const { user } = storeToRefs(useUserSettingsStore());
const { productTourCompleted, onboardingCompleted } =
  storeToRefs(useUserStore());
</script>
